import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, Link, useLocation, useParams } from "react-router-dom";
import store from "../../store";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from "@mui/material/TextField";

import { CONTACT_US_URL } from "../../utils/api-ends";
import useHttp from "../../hooks/useHttp";
import LoaderImg from "../../assets/media/loader.gif";
import "../../assets/css/contact-us.css";

const ContactUs = () => {

	const { isLoading, sendRequests, error } = useHttp();
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [body, setBody] = useState("");
  const [emailError, setEmailError] = useState("");
  const [reasonError, setReasonError] = useState("");
  const [bodyError, setBodyError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");


  const onEmailChange = (e) => { 
    setEmail(e.target.value);
    setEmailError("")
  }
  const onReasonChange = (e) => { 
    setReason(e.target.value);
    setReasonError("")
  }
  const onBodyChange = (e) => {
    setBody(e.target.value);
    setBodyError("")
  }


  const onSubmit = (e) => { 
    const formData = new FormData();
    formData.append("email", email);
    formData.append("reason", reason);
    formData.append("body", body);

    const response = (data) => {
        setSuccessMessage(data.message)

        // Clear success messages
          setTimeout(() => {
              setSuccessMessage("")
              setEmail("")
              setReason("")
              setBody("")
              setEmailError("")
              setReasonError("")
              setBodyError("")
          }, 3000);
    }

    sendRequests(
      {
        method: "post",
        url: CONTACT_US_URL,
        data: formData,
      },
      response
    );
  }


  useEffect(() => {
    if (error) {
      if(error?.field_related_errors?.email){
        setEmailError(error?.field_related_errors?.email?.message)
      }
      if(error?.field_related_errors?.reason){
        setReasonError(error?.field_related_errors?.reason?.message)
      }
      if(error?.field_related_errors?.body){
        setBodyError(error?.field_related_errors?.body?.message)
      }
    }
  }, [error]);



  return (
    <>

    <section>
        <div className="our-address-on-map">
            <img src="https://lh3.googleusercontent.com/fife/AAWUweVpl7GtN65hEkH4-GRXpCrUODfjHT-OKlMG6gzGM4XUdUhS0peiU2cn0_y0n962k5u0z7FDPXtIXISnnvqTLEFg91knlfwJ2V3sZ48clgrhVZvrnIEcZi2fUsI-qj2T4Y5gaTvJJS7PQBc4Png-T8kzKI-D9gvohSUzozVMt-HUbARQvso85Exfg6zaxNJg8J4b_V9imZEtUt5VDYjUgzLgUd2UcK4NQe2FyTfRhXs8xKf8QC_3DbkjtT7KyfVmwTEU2vc2LO5uWSe2EspDtfkA_Ehgpa730FC-iJYEfRsMD6Dw8irYBgDcUjVhpaa3qh1VOV7q6FdVUsd6ssUND7VMDDaCn6UQgDAAK4Ge3u_d2vZV8UZGeDPTZqM4_BEfqfw-OysR_z_-P8RsL7GPzSabceZr-1FOT043YOq5d4JVdPiJn73ZAyljMprTJnjpxbH-7ZiufINnFXhV4NohIXCjqszPl_RNRwvzDSsabasVoZ1TlUC23bA9HEr_JsU2NALvcIo_kECEjGM5Ws9tJGM48-Ld6J3k_PYQ_HXgKvk60Kq_W72gLAw-LLrXrBOk7PqabjIIVkqSGMj1dLdkLlDO26CaakhaLQ-C7UXdMVlWnWyEeaWAvjkNthEmAzeXB41u6j4T5CqHpNJEZQbsEvkroD0odqLUUtN2NKHT8m2oWzz6w5WP4VGzrszImgrH_RtL97RIs-z6XF820KQAktjzG85yyIL2paYDuDlnBNXecGr_CyZCqzd5_gOUQ5rydiF4MlfEE934v-hnbwV8Sw8cBn_o5l2pZwTp01V2HLtQu0Zi_AM2KbplH8YZvxNljRlNeJGwdoSkD0z120qBP3eIeACVfPpa-IZq2sFAfarMlKqyjmq5okKWS8a3u9SJNUhm1nXKINm52peSp8z4UF-2gnGojj-JuQs9KGxOisE2k8odpE1fGoCcOqUqTwOcZX4zmElZi1UWJqQg5zWviRVyAfxUmRhyxhxB2vbOLSDK2C6dmGZJbBaYjlHXP2f0ulCaTvQtlIUZn07KxfFVFH2ZFcEDy1p6ntqnMKdPpitcD4cCwGXGTzbbVVn3QahIe0cRjfp8OYM0yJV1Mx3bs5lPKbaiQGbUYKWpYEd20-PFoBZGnBWmA9XfhDgCJldI6KJDvzm3DjFDFENGkg-nDywWHcLMmzYtABcI6060LoeW6vXVOmgOvabz_9naPyIu-aHRTlsAqSP4WxAF1cSqPXdUAaJBoG2VmpozZMX6xQC-qKKRUW0ijMOXqKAEUMcj18HUxS-3ag=w1920-h961" alt="" />
        </div>
    </section>

    <section id="our-address">
        <div className="container">
            <div className="row">
                <div className="col-lg-5 contact-info">
                    <h1 className="large-text"> Contact Info</h1>

                    <div className="detail-contact-info">
                        <div className="contact-icon">
                            <i className="fa-regular fa-envelope"></i>
                        </div>
                        <p>demosupport@email.com</p>
                    </div>

                    <div className="detail-contact-info">
                        <div className="contact-icon">
                            <i className="fa-solid fa-mobile-retro"></i>
                        </div>
                        <p>240-478-2730</p>
                    </div>

                    <div className="detail-contact-info">
                        <div className="contact-icon">
                            <i className="fa-solid fa-map-location-dot"></i>
                        </div>
                        <p>
                            Padmore Global Connections LLC, 1481 Osage Road, North Brunswick, NJ 08902
                        </p>
                    </div>
                </div>



                <div className="col-lg-7 messaging-box">
                    <h1 className="large-text"> Send Us Message</h1>

                    <p className="auth-instruction SuccessMessage_SuccessMsg__fTMdE withdrawAmount-success-message">{successMessage}</p>

                    <div className="messaging-box-form">
                        <div className="input-box-area">
                            <p className="auth-error" >{emailError}</p>
                            <TextField fullWidth className="the-mui-input-field" label="Email" variant="outlined" onChange={onEmailChange} value={email} />
                        </div>

                        <div className="input-box-area">
                          <p className="auth-error" >{reasonError}</p>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Reason</InputLabel>
                            <Select labelId="demo-simple-select-label" id="demo-simple-select" label="reason" onChange={onReasonChange} value={reason} >
                              <MenuItem value={1}>General Query</MenuItem>
                              <MenuItem value={2}>Query Related To Order</MenuItem>
                              <MenuItem value={3}>Other</MenuItem>
                            </Select>
                          </FormControl>
                        </div>

                        <div className="input-box-area">
                            <p className="auth-error" >{bodyError}</p>
                            <TextField fullWidth className="the-mui-input-field contact-reason-style" label="Body" variant="outlined" onChange={onBodyChange} value={body} />
                        </div>

                        <div className="multiple-btn">
                            <button className="m-0" onClick={onSubmit} >Send</button>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </section> 

    </>
  );
};

export default ContactUs;
